module.exports = __webpack_public_path__ + "img/c.f8636a28.jpg";